import './analytics.css'
import { Box, Card, Divider, Stack, styled, Typography } from '@mui/material'
import {
    useGetPatientByIdLastOne,
    useGetPatientData,
} from 'app/hooks/usePatient'
import React, { useRef } from 'react'
import AnalyzerToolbar from '../AnalyzerToolbar'
import { HightWeight } from './HeightWeight'
import { BMISection } from './BMISection'
import { AnotherMeasurementSection } from './AnotherMeasurementSection'
import moment from 'moment'
import { CardMeasurement } from './CardMeasurement'
import { useReactToPrint } from 'react-to-print'
import { useGetPatientByIdCountByDate } from 'app/hooks/usePatient'
import { ChartY } from '../Analytics'
import PatientDataTable from './PatientDataTable'

const ContentBox = styled('div')(({ theme }) => ({
    margin: '30px',
    gap: '2px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
}))
const PatientData = () => {
    const { patient } = useGetPatientData()
    const { data } = useGetPatientByIdLastOne()
    const { data: countByDate } = useGetPatientByIdCountByDate()
    const contentRef = useRef(null)
    const reactToPrintFn = useReactToPrint({ contentRef })
    return (
        <div className="print-area" ref={contentRef}>
            <ContentBox>
                <AnalyzerToolbar disableExcel onPrint={reactToPrintFn} />
                <Stack gap={2} direction={'column'}>
                    <Stack spacing={2}>
                        <Stack
                            spacing={2}
                            component={'div'}
                            id="summary_card-1-200-200"
                        >
                            <Typography variant="h6" component={'hุ6'}>
                                รายงานผลข้อมูลสุขภาพส่วนบุคคล
                            </Typography>
                            <Typography variant="subtitle1">
                                หมายเลขประจำตัวผู้รับบริการ {data?.cid}
                            </Typography>
                            <Card>
                                <Stack py={4} px={2} spacing={2}>
                                    <Typography
                                        variant="h6"
                                        color={'#303030'}
                                        component={'h6'}
                                    >
                                        ผลการคัดกรองล่าสุด{' '}
                                        {moment
                                            .unix(data?.mea_timestamp)

                                            .format('DD/MM/YYYY')}
                                    </Typography>
                                </Stack>
                            </Card>
                            {patient && <CardMeasurement data={patient} />}
                            {/* TODO: ข้อมูลสุขภาพตามช่วงเวลา */}
                            <PatientDataTable />
                        </Stack>
                    </Stack>
                    <Card
                        sx={{
                            backgroundColor: 'primary.main',
                            color: 'white',
                        }}
                        component={'div'}
                        id="summary_card-1-200-200"
                    >
                        <Box p={2}>
                            <Stack spacing={2}>
                                <Stack spacing={2}>
                                    <Typography
                                        variant="body1"
                                        component={'h6'}
                                    >
                                        ค่าดัชนีมวลกาย
                                    </Typography>
                                    <HightWeight
                                        data={
                                            patient?.['HEIGHT,WEIGHT,BMI']?.at(
                                                -1
                                            )?.['measurements']
                                        }
                                    />
                                    <BMISection
                                        data={
                                            patient?.['HEIGHT,WEIGHT,BMI']?.at(
                                                -1
                                            )?.['measurements']
                                        }
                                    />
                                    <Divider />
                                    <AnotherMeasurementSection
                                        time={
                                            patient?.['SMOKE,ALCOLHOL']?.at(-1)
                                                ?.mea_timestamp
                                        }
                                        data={
                                            patient?.['SMOKE,ALCOLHOL']?.at(-1)
                                                ?.measurements
                                        }
                                    />
                                    {/* <DepressionSection /> */}
                                </Stack>
                            </Stack>
                        </Box>
                    </Card>
                </Stack>
            </ContentBox>
        </div>
    )
}

export default PatientData
